import { AxiosResponse as Response } from "axios";

import Api from "@/modules/axios";
import Tache from "@/domains/taches/tache";

interface ResponseMultiple<T = any> {
  results: T[];
}

export default class TacheRepository {
  static apiVersObjet(data: Tache): Tache {
    return new Tache(data);
  }

  async recupererTout(): Promise<Tache[]> {
    const response: Response<ResponseMultiple<Tache>> = await Api().get("/tache/?page_size=100");
    return response.data.results.map((tache) => TacheRepository.apiVersObjet(tache));
  }
}
